/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { AlertIcon } from "@dotnet/telematics-design-system";

import { useStyles } from "./styles";

interface PaperBoxProps {
  children: ReactNode;
  customStyling?: any;
  boxTitle?: string;
  paperTitle?: string;
  paperDescription?: string;
  testId?: string;
  errorText?: string | null;
  noBottomPadding?: boolean;
  paperBoxRef?: (element: Element | null) => void;
}

const PaperBox = ({
  children,
  customStyling,
  boxTitle,
  paperTitle,
  paperDescription,
  testId,
  errorText,
  noBottomPadding,
  paperBoxRef
}: PaperBoxProps) => {
  const { paperBox, boxTitleArea, errorIconStyles } = useStyles();

  return (
    <div
      data-testid={testId ?? "paper-box"}
      ref={paperBoxRef}
      className="paper-box"
      css={css({
        height: "100%",
        display: "flex",
        flexDirection: "column"
      })}
    >
      {boxTitle && (
        <Typography
          variant="body2Medium"
          sx={boxTitleArea as {}}
          component="div"
        >
          {boxTitle}
        </Typography>
      )}

      <Paper
        elevation={0}
        variant="outlined"
        sx={[paperBox as {}, customStyling]}
        css={css({
          height: "100%",
          display: "flex",
          flexDirection: "column"
        })}
      >
        <div
          css={css(
            !noBottomPadding && {
              paddingBottom: "16px"
            }
          )}
        >
          {paperTitle && (
            <Typography variant="body1Medium">{paperTitle}</Typography>
          )}

          {paperDescription && (
            <Typography
              variant="body2Regular"
              sx={{ marginTop: "8px" }}
              component="div"
            >
              {paperDescription}
            </Typography>
          )}
        </div>

        {children}
      </Paper>

      {errorText && (
        <div
          css={{
            display: "flex",
            alignItems: "center",
            margin: "6px 0 0 0",
            justifyContent: "flex-start"
          }}
        >
          <AlertIcon data-testid="error-icon" css={css(errorIconStyles)} />
          <Typography variant="body2Medium">{errorText}</Typography>
        </div>
      )}
    </div>
  );
};

export default PaperBox;
